import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { CurrentUserState } from '../types';
import { useCurrentUserModule } from '../useModule';
import { DismissQuickTip as DismissQuickTipCommand } from '@/api/currentUser/commands';

const { registerMiddleware, registerReducer } = useCurrentUserModule();

export class DismissQuickTip extends Action<CurrentUserState> {
    public static ACTION_TYPE = 'DismissQuickTip';

    public constructor(public dismissKey: string) {
        super(DismissQuickTip.ACTION_TYPE);
    }
}

const middleware = async (state: CurrentUserState, action: DismissQuickTip): Promise<boolean> => {
    if (state.dismissedQuickTipKeys.includes(action.dismissKey)) {
        return false;
    }

    return await useSendCommand(action, {
        createCommand: () => new DismissQuickTipCommand(action.dismissKey),
    });
};

const reducer = (state: CurrentUserState, action: DismissQuickTip): void => {
    state.dismissedQuickTipKeys.push(action.dismissKey);
};

//@ts-ignore
registerMiddleware(DismissQuickTip.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DismissQuickTip.ACTION_TYPE, reducer);
